<template>
  <v-row>
    <v-col cols="12" md="6" class="pt-0 pb-0 pr-5">
      <v-row>
        <v-col cols="12" md="12" class="mx-3 mt-2 pa-0">
          <v-form>
            <v-row>
              <v-col cols="12" md="1" class="pt-0 pr-0">
                <v-label class="mb-2 pb-3"><span style="font-size: 13px">Name</span></v-label>
              </v-col>
              <v-col cols="12" md="5" class="d-flex align-center py-0 px-0">
                <v-text-field
                  v-model="saveData.CONF_NAME"
                  class="custom-selectbox ml-2"
                  :rules="[validationUtils.required]"
                  dense
                  solo
                  filled
                  @keyup="
                    checkAgent();
                    checkSave();
                  "
                  :disabled="!allowEdit"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="d-flex py-0 px-0">
                <v-menu
                  :close-on-content-click="false"
                  offset-y
                  content-class="load-menu"
                  v-model="menuOpen"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="cus-bg-svg white--text py-2 px-3 ml-3 mr-2"
                      v-on="on"
                      :disabled="!agentId || (type === 'D2D' && !targetAgentId)"
                      v-show="!dbaId || dbaId == '0'"
                    >
                      <icon-svg iconName="Load" />
                    </v-btn>
                  </template>
                  <v-card style="height: 272px">
                    <v-data-iterator
                      :search="search"
                      :items="dbConfig"
                      :server-items-length="dbConfig.length"
                      style="max-height: 272px; overflow-x: hidden"
                      class="overflow-y-auto row-config-item"
                      hide-default-footer
                    >
                      <template v-slot:header>
                        <v-row class="mt-5 mb-5" no-gutters>
                          <v-col cols="12" class="pt-0 pb-0 pl-0 pr-0">
                            <v-text-field
                              v-model="search"
                              prepend-inner-icon="mdi-magnify"
                              heigth="30"
                              placeholder=""
                              single-line
                              dense
                              solo
                              class="custom-selectbox"
                              hide-details
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </template>

                      <template v-slot:default="{ items }">
                        <v-row v-for="item in items" :key="item.config_name" dense class="mt-5">
                          <v-col
                            cols="12"
                            class="map-text-field inline-block-component config-load pt-0 pb-0"
                          >
                            <v-list-item-title height="25px">
                              <v-btn
                                height="20px"
                                text
                                ripple
                                class="btn"
                                block
                                :disabled="item.numofuse > 0"
                                @click="handleChangeConfigData(item.value)"
                                style="justify-content: left"
                              >
                                <font>{{ item.text }}</font>
                              </v-btn>
                            </v-list-item-title>
                            <div class="mr-2">
                              <v-list-item-title height="25px">
                                <v-btn
                                  x-small
                                  text
                                  icon
                                  @click.stop="handleChangeAndCopyConfigData(item.value)"
                                >
                                  <icon-svg iconName="copy" />
                                </v-btn>
                                <v-btn
                                  x-small
                                  text
                                  icon
                                  :disabled="item.numofuse > 0"
                                  @click.stop="handleDelete(item)"
                                >
                                  <icon-svg :disabled="item.numofuse > 0" iconName="delete" />
                                </v-btn>
                              </v-list-item-title>
                            </div>
                          </v-col>
                        </v-row>
                      </template>
                      <template v-slot:no-data>
                        <v-container fluid class="fill-height justify-center align-center">
                          <v-row justify="center">
                            <v-col cols="auto">
                              <p class="text-h6">No data available.</p>
                            </v-col>
                          </v-row>
                        </v-container>
                      </template>
                    </v-data-iterator>
                  </v-card>
                </v-menu>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
        <v-col cols="12" md="12" class="ma-3 mt-0 pa-0 bg-db-left">
          <v-form ref="form">
            <v-row class="mx-3 mb-0 mt-3">
              <v-col cols="12 py-0" md="4">
                <v-label><span>Origin System</span></v-label>
                <v-text-field
                  v-model="saveData.CONF_FROM"
                  class="custom-selectbox mt-1"
                  :rules="[validationUtils.required, validationUtils.max(10)]"
                  dense
                  solo
                  filled
                  @keyup="
                    checkAgent();
                    handleChangeName();
                    checkSave();
                  "
                  :disabled="$route.params.action == 'Edit'"
                ></v-text-field>
              </v-col>
              <v-col cols="12 py-0" md="4">
                <v-label><span>Target System</span></v-label>
                <v-text-field
                  v-model="saveData.CONF_TO"
                  class="custom-selectbox mt-1"
                  :rules="[validationUtils.required, validationUtils.max(10)]"
                  dense
                  solo
                  filled
                  @keyup="
                    checkAgent();
                    handleChangeName();
                    checkSave();
                  "
                  :disabled="$route.params.action == 'Edit'"
                ></v-text-field>
              </v-col>
              <v-col cols="12 py-0" md="4">
                <v-label><span>Interface Module</span></v-label>
                <v-text-field
                  v-model="saveData.CONF_MODULE"
                  class="custom-selectbox mt-1"
                  :rules="[validationUtils.required, validationUtils.max(10)]"
                  dense
                  solo
                  filled
                  @keyup="
                    checkAgent();
                    handleChangeName();
                    checkSave();
                  "
                  :disabled="$route.params.action == 'Edit'"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="mx-3 my-0">
              <v-col cols="12 py-0" md="4">
                <v-label><span>DB Instance</span></v-label>
                <v-select
                  v-model="saveData.CONF_DBINSTANCE"
                  :items="dbInstnList"
                  @change="
                    handleChangeName();
                    checkSelectBoth();
                    checkSave();
                  "
                  :menu-props="{ offsetY: true }"
                  class="custom-selectbox mt-1"
                  :rules="[validationUtils.required]"
                  dense
                  solo
                  filled
                  @keyup="checkAgent()"
                ></v-select>
              </v-col>
              <v-col cols="12 py-0" md="3">
                <v-label><span>Interface Control Table</span></v-label>
                <v-select
                  v-model="saveData.CONF_TABLE"
                  :items="controlTableList"
                  @change="
                    checkSelectBoth();
                    checkSave();
                  "
                  :menu-props="{ offsetY: true }"
                  class="custom-selectbox mt-1"
                  :rules="[validationUtils.required]"
                  dense
                  solo
                  filled
                  @keyup="checkAgent()"
                ></v-select>
                <p
                  v-if="connect === 'success'"
                  class="ma-0 text-validate completed"
                  style="position: relative; top: -10px"
                >
                  <icon-svg size="14" style="display: inline" iconName="completed" />Connected!
                </p>
                <p
                  v-if="connect === 'fail'"
                  class="ma-0 text-validate"
                  style="position: relative; top: -10px"
                >
                  <icon-svg size="16" style="display: inline" iconName="validate" />Unable to
                  connect.
                </p>
              </v-col>
              <v-col cols="12 py-0" md="5">
                <v-row>
                  <v-col cols="12 py-0" md="12">
                    <v-label><span>Where Phrase</span></v-label>
                    <div class="d-flex">
                      <v-textarea
                        v-model="saveData.WHERE_PHRASE"
                        height="53"
                        class="ma-0 mt-1"
                        style="font-size: 10px; color: #e6eaf0"
                        hide-details
                        solo
                        filled
                        @keyup="
                          checkAgent();
                          checkSave();
                        "
                      ></v-textarea>
                      <div
                        @click="selectQueryList('phrase')"
                        class="ml-2 mt-1 btn-query d-flex align-center"
                      >
                        Query
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row v-if="requiredCondition" class="mx-3 my-0">
              <v-col cols="12" class="pa-0 py-0 mx-3" style="height: 30px">
                <span style="font-size: 12px; color: #b71c1c">{{ requiredCondition }}</span>
              </v-col>
            </v-row>

            <v-row class="mx-3 my-0">
              <v-col cols="6" class="pa-0 py-0" v-if="type !== 'J2D'">
                <v-row class="ml-0 mr-3">
                  <v-col cols="12">
                    <v-form ref="formEDI" class="dialog-content add-partner-dialog pr-0">
                      <v-row class="mx-0 mt-0 mb-3">
                        <v-col cols="12" lg="6" class="pa-0">
                          <v-label> Interface Condition </v-label>
                          <v-icon
                            dense
                            @click="addInterface()"
                            :disabled="!agentId || (type === 'D2D' && !targetAgentId)"
                            >mdi-plus</v-icon
                          >
                        </v-col>
                        <v-col cols="12" lg="4" class="pa-0 ml-2 mt-1 d-flex align-end justify-end">
                          <div
                            @click="selectQueryList('interface')"
                            class="btn-query d-flex align-center"
                          >
                            Query
                          </div>
                        </v-col>
                      </v-row>
                      <div style="height: 200px; overflow-y: auto">
                        <v-row
                          class="ml-0 mr-0 edi-identification"
                          v-for="(item, index) in listInterface"
                          :key="index"
                        >
                          <v-col lg="5" class="pa-0">
                            <v-autocomplete
                              :ref="'COL_' + item.id"
                              v-model="item.col"
                              :items="columnName"
                              :menu-props="{ offsetY: true }"
                              placeholder="Column Name"
                              class="custom-selectbox"
                              :rules="[validationUtils.required]"
                              dense
                              solo
                              filled
                              @keyup="
                                checkAgent();
                                checkSave();
                              "
                            ></v-autocomplete>
                          </v-col>
                          <v-col lg="5" class="pa-0 ml-2">
                            <v-text-field
                              :ref="'VAL_' + item.id"
                              v-model="item.val"
                              placeholder="Condition"
                              :maxlength="50"
                              solo
                              :rules="[validationUtils.required]"
                              @keyup="
                                checkAgent();
                                checkSave();
                              "
                            ></v-text-field>
                          </v-col>
                          <v-col lg="1" class="pa-0 ml-3 mr-0 d-flex">
                            <div class="btn-tooltip">
                              <v-icon
                                :disabled="
                                  !agentId ||
                                    (type === 'D2D' && !targetAgentId) ||
                                    listInterface.length <= 1
                                "
                                dense
                                @click="
                                  removeInterface(item, index);
                                  checkAgent();
                                  checkSave();
                                "
                                style="height:20px;margin-top:10px;"
                                >mdi-minus</v-icon
                              >
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6" class="pa-0 py-0">
                <v-row class="ml-0 mr-3">
                  <v-col cols="12">
                    <v-row class="mx-0 mt-0 mb-3">
                      <v-col cols="12" lg="12" class="pa-0">
                        <v-label><span>Status Update</span></v-label>
                      </v-col>
                    </v-row>
                    <v-row
                      v-for="(item, index) in statusUpdate"
                      :key="index"
                      class="mx-0 mt-0 edi-identification"
                    >
                      <v-col lg="2" class="pa-0 ml-4 mr-2 d-flex align-center">
                        <font class="font-status-update">{{ item.name }}</font>
                      </v-col>
                      <v-col lg="5" class="pa-0">
                        <v-autocomplete
                          v-model="item.col"
                          :items="columnName"
                          :menu-props="{ offsetY: true }"
                          placeholder="Column Name"
                          :rules="
                            item.name === 'Processing' || item.name === 'Complete'
                              ? [validationUtils.required]
                              : []
                          "
                          dense
                          solo
                          @keyup="
                            checkAgent();
                            checkSave();
                          "
                        ></v-autocomplete>
                      </v-col>
                      <v-col lg="3" class="pa-0 ml-2">
                        <v-text-field
                          v-model="item.val"
                          placeholder="Status"
                          :maxlength="50"
                          solo
                          :rules="
                            item.name === 'Processing' || item.name === 'Complete'
                              ? [validationUtils.required]
                              : []
                          "
                          @keyup="
                            checkAgent();
                            checkSave();
                          "
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>

      <v-row v-if="$auth.manage">
        <v-col class="btn-form-control data-query-section pt-0 pr-0 ml-3" lg="12">
          <div class="btn-form-control text-right">
            <v-btn
              v-if="!saveData.CONF_ID"
              class="btn-active btn-search"
              @click="onSave"
              :disabled="!agentId || (type === 'D2D' && !targetAgentId)"
            >
              Create
            </v-btn>
            <v-btn
              v-else
              class="btn-active btn-search"
              @click="onSave"
              :disabled="!agentId || (type === 'D2D' && !targetAgentId)"
              >{{ $t('lbl.partners.save') }}</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12" md="6" class="pl-5 pr-4 pt-0">
      <v-row class="ml-1" style="width: 100%">
        <v-col cols="12" md="9" class="pl-0">
          <v-label class="pb-3"
            ><span class="text-base">Interface Control Table Data</span></v-label
          >
        </v-col>
        <v-col lg="3" class="pa-0 mt-4">
          <v-text-field
            v-model="textSearch"
            ref="searchFilterData"
            placeholder="Search Text"
            solo
            hide-details
            dense
            filled
            @input="searchQueryData()"
            @keyup="checkAgent()"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="12" class="mb-3 mt-1 pa-0 bg-db-left">
          <hot-table id="hotTableComponent" ref="hotTableComponent" :settings="hotSettings">
          </hot-table>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="btn-form-control data-query-section d-flex justify-end pt-0" lg="12" col="12">
          <div style="width: fit-content; padding-right: 30px;" class="text-left align-self-center">
            <p
              v-for="(item, index) in sqlMessList"
              :key="index"
              :class="'mb-0 text-validate ' + item.icon"
            >
              <icon-svg style="display: inline; height: fit-content" :iconName="item.icon" />{{
                item.message
              }}
            </p>
          </div>
          <div class="btn-form-control text-right">
            <v-btn
              v-if="$auth.manage"
              class="btn-active btn-search"
              :disabled="!agentId || (type === 'D2D' && !targetAgentId)"
              @click="onSaveQuery"
              >{{ $t('lbl.partners.save') }}</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </v-col>
    <dialogWindow
      ref="validateName"
      size="max"
      :detail="add_valid_str"
      color="validation"
    ></dialogWindow>
    <dialogWindow ref="fail" size="max" detail="Fail" color="error"></dialogWindow>
    <dialogWindow
      ref="updateConfig"
      size="max"
      title="Update DB config"
      detail="You have changed some information and this config will be apply for more DB Adapter. Do you want to continue ?"
      color="confirmation"
      :showCancel="true"
      @select-ok="confirmSave()"
    ></dialogWindow>
    <dialogWindow
      ref="WarningDialog"
      size="max"
      title="Warning"
      :detail="warnDetail"
      color="warning"
    >
    </dialogWindow>
    <dialogWindow
      ref="confirmDeleteFileDialog"
      size="max"
      :info="deleteDataName"
      title="confirmDialog"
      :detail="$t('msg.dbInterfaceConfig.deleteConfirm')"
      color="confirmation"
      :dataValue="deleteData"
      @select-ok="okDeleteDBConfig($event)"
      :showCancel="true"
    ></dialogWindow>
  </v-row>
</template>

<script>
import IconSvg from '@/vue-caas/components/IconBase.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { nullOrEmpty } from '@/vue-dlb/common/common';
import { HotTable } from '@handsontable/vue';
import 'handsontable/dist/handsontable.full.css';

export default {
  props: {
    type: String,
    comId: String,
    agentId: String,
    dbaId: String,
    targetAgentId: String,
    dbConfigList: Array,
    dbInstnList: Array,
    controlTableList: Array,
  },
  components: {
    IconSvg,
    dialogWindow,
    HotTable,
  },
  data() {
    let self = this;
    return {
      connect: '',
      requiredCondition: '',
      sqlMessList: [],
      warnDetail: '',
      dbType: '',
      listInterface: [{ id: 0, val: '' }],
      listInterfaceDelete: [],
      statusUpdate: [
        { val: '', name: 'Processing' },
        { val: '', name: 'Complete' },
        { val: '', name: 'Error' },
        { val: '', name: 'Extra' },
      ],
      saveData: {
        CONF_ID: '',
        SQL_SELECT: [],
        SQL_PROCESS: [],
        SQL_COMPLETE: [],
        SQL_ERROR: [],
        SQL_EXTRA: [],
      },
      originData: {},
      value: '',
      dbConfig: [],
      columnName: [],
      dataRows: [],
      comp_id: '',
      agent_id: '',
      add_valid_str: '',
      menuOpen: false,
      search: '',
      deleteData: '',
      deleteDataName: '',
      allowSave: false,
      allowEdit: true,
      hotSettings: {
        licenseKey: 'non-commercial-and-evaluation',
        copyPaste: true,
        colHeaders: [
          'msg_seq_no',
          'sys_from',
          'sys_to',
          'if_module_id',
          'msg_name',
          'in_out_ind',
          'proc_sts',
          'upd_dt',
          'upd_usr_id',
        ],
        columns: [
          { data: 'MSG_SEQ_NO' },
          { data: 'SYS_FROM', readOnly: true },
          { data: 'SYS_TO', readOnly: true },
          { data: 'IF_MODULE_ID', readOnly: true },
          { data: 'MSG_NAME' },
          { data: 'IN_OUT_IND' },
          { data: 'PROC_STS' },
          { data: 'UPD_DT', readOnly: true },
          { data: 'UPD_USR_ID', readOnly: true },
        ],
        hiddenColumns: {
          columns: [0],
          indicators: true,
        },
        beforePaste: function(data, coords) {
          if (data.length > 100) {
            self.$refs.WarningDialog.dialog = true;
            self.warnDetail = self.$t('msg.dbAdapter.check100');
            return false;
          }
        },
        beforeRemoveRow: function(index, amount, physicalRows) {
          physicalRows.forEach((row) => {
            self.removeRow(this.getSourceDataAtRow(row));
            this.getCellMeta(row, 4).valid = true;
            this.getCellMeta(row, 5).valid = true;
            this.getCellMeta(row, 6).valid = true;
          });
        },
        afterChange: function(changes, source) {
          if (self.addActive || !changes) return;
          changes.forEach(([row, prop, oldValue, newValue]) => {
            if (newValue != oldValue) self.updatedRow(this.getSourceDataAtRow(row));
          });
        },
        contextMenu: {
          items: {
            row_last: {
              disabled: function() {
                return this.countRows() > 99;
              },
              name: 'Insert last',
              callback: function() {
                this.alter('insert_row', this.countRows());
                this.selectCell(this.countRows() - 1, 'MSG_NAME');
                this.setDataAtCell(this.countRows() - 1, 1, self.saveData.CONF_FROM);
                this.setDataAtCell(this.countRows() - 1, 2, self.saveData.CONF_TO);
                this.setDataAtCell(this.countRows() - 1, 3, self.saveData.CONF_MODULE);
              },
            },
            refresh: {
              name: 'Refresh',
              callback: function() {
                self.resetSave();
                self.checkSelectBoth();
              },
            },
          },
        },
        width: '100%',
        height: 450,
        colWidths: (col) => {
          const w = document.getElementById('hotTableComponent').clientWidth;
          return w / 8;
        },
        rowHeights: 25,
        startRows: 1,
        startCols: 3,
        columnSorting: true,
        autoWrapCol: false,
        invalidCellClassName: 'redCell',
        autoRowSize: true,
      },
      deleteList: [],
      updateList: [],
      uploadQueryPool: [],
      textSearch: '',
    };
  },
  computed: {
    ...mapState('analysis', {
      fileViewWindowParam: 'fileViewWindowParam',
    }),
    ...mapGetters(['interfaceColumnList', 'dbAdapter', 'dbAdapterConfigList']),
  },
  watch: {
    type() {
      this.dbType = this.type;
    },
    dbConfigList() {
      this.dbConfig = this.dbConfigList;
    },
    comId() {
      this.comp_id = this.comId;
    },
    agentId() {
      this.agent_id = this.agentId;
    },
  },
  async created() {
    let dbaId = nullOrEmpty(this.dbaId);
    if (dbaId && dbaId != '0') {
      let param = this.fileViewWindowParam[this.$route.params.id];
      this.comp_id = param.editedItem.comp_id;
      this.agent_id = param.editedItem.agent_id;
      this.dbConfig = this.dbConfigList;
      this.dbType = this.type;
      this.statusUpdate = [];
      this.loadItem(param.editedItem.dba_conf_id);
    } else {
      this.comp_id = this.comId;
      this.agent_id = this.agentId;
      this.resetDBConfigData();
    }
  },
  methods: {
    ...mapActions(['getInterfaceColumnList', 'selectQueryList', 'manageQueryList']),
    removeRow(item) {
      if (item.MSG_SEQ_NO) {
        let record = {
          SYSSTATUS: 'D',
          MSG_SEQ_NO: item.MSG_SEQ_NO,
        };
        this.removeFromUpdateList(record);
        if (this.deleteList.findIndex((element) => element.MSG_SEQ_NO == record.MSG_SEQ_NO) == -1)
          this.deleteList.push(record);
      }
    },
    removeFromUpdateList(record) {
      let index = this.updateList.findIndex((element) => element.MSG_SEQ_NO == record.MSG_SEQ_NO);
      if (index > -1) this.updateList.splice(index, 1);
    },
    updatedRow(item) {
      if (item.MSG_SEQ_NO) {
        let record = {
          SYSSTATUS: 'U',
          MSG_SEQ_NO: item.MSG_SEQ_NO,
          MSG_NAME: item.MSG_NAME,
          IN_OUT_IND: item.IN_OUT_IND,
          PROC_STS: item.PROC_STS,
        };

        let index = this.updateList.findIndex((element) => element.MSG_SEQ_NO == record.MSG_SEQ_NO);
        if (index > -1) this.updateList.splice(index, 1);
        this.updateList.push(record);
      }
    },
    onSaveQuery() {
      this.sqlMessList = [];
      this.uploadQueryPool = [];
      console.log('--------- Check data ----------');
      let _this = this.$refs.hotTableComponent.hotInstance;
      if (_this.countRows() > 100) {
        self.$refs.WarningDialog.dialog = true;
        self.warnDetail = self.$t('msg.dbAdapter.check100');
        return;
      }
      let data = _this.getData();
      let _rows = data.length;
      let row = -1,
        col = -1;
      // Check empty
      for (let i = 0; i < _rows; i += 1) {
        // Reset valid
        _this.getCellMeta(i, 4).valid = true;
        _this.getCellMeta(i, 5).valid = true;
        _this.getCellMeta(i, 6).valid = true;
        // If empty row => pass
        if (_this.isEmptyRow(i)) continue;
        // Check column data
        if (this.isEmpty(data[i][4])) {
          // QR_NM
          _this.getCellMeta(i, 4).valid = false;
          if (col == -1) col = 4;
          if (row == -1) row = i;
        }
        if (this.isEmpty(data[i][5])) {
          // QR_TP
          _this.getCellMeta(i, 5).valid = false;
          if (col == -1) col = 5;
          if (row == -1) row = i;
        }
        if (this.isEmpty(data[i][6])) {
          // QR_TXT
          _this.getCellMeta(i, 6).valid = false;
          if (col == -1) col = 6;
          if (row == -1) row = i;
        }
      }
      if (row > -1) {
        _this.render();
        return _this.selectCell(row, col);
      }
      data.map((e, i) => {
        let item = _this.getSourceDataAtRow(i);
        if (!_this.isEmptyRow(i) && !item.MSG_SEQ_NO)
          this.uploadQueryPool.push({
            SYSSTATUS: 'I',
            MSG_SEQ_NO: '',
            SYS_FROM: e[1],
            SYS_TO: e[2],
            IF_MODULE_ID: e[3],
            MSG_NAME: e[4],
            IN_OUT_IND: e[5],
            PROC_STS: e[6],
          });
      });
      // Join delete list
      this.uploadQueryPool = this.uploadQueryPool.concat(this.deleteList);
      // Join update list
      this.uploadQueryPool = this.uploadQueryPool.concat(this.updateList);

      // Check save list
      if (this.uploadQueryPool.length == 0) {
        this.sqlMessList.push({
          icon: 'validate',
          message: this.$t('msg.dbBroker.queryPool.noData'),
        });
        return;
      }

      //Remove \n before save to database
      data = JSON.stringify(this.uploadQueryPool).replace(/\\n/g, '');
      console.log('--------- savaData ----------', data);
      this.manageQueryList();
    },
    isEmpty(value) {
      return !value || !value.replace(/\s/g, '').length ? true : false;
    },
    copyDBIFConfig() {
      this.saveData.CONF_ID = '';
      this.saveData.CONF_NAME = '';
      this.$store.commit('SET_STORE_DBCONFIG_ID', '');
    },
    checkAgent() {
      if (!this.agentId) {
        this.add_valid_str = 'Company and Agent must be selected.';
        this.$refs.validateName.dialog = true;
      } else if (this.type === 'D2D' && !this.targetAgentId) {
        this.add_valid_str = 'Agent must be selected.';
        this.$refs.validateName.dialog = true;
      }
    },
    checkSave() {
      this.getParamSave();
      const editedData = this.getEditData(this.saveData, this.originData);
      if (Object.keys(editedData).length !== 0) {
        this.allowSave = true;
      } else {
        this.allowSave = false;
      }
    },
    getParamSave() {
      this.saveData.dba_conf_id = this.saveData.CONF_ID;
      this.saveData.dba_id = this.dbaId;
      this.saveData.agent_id = this.agent_id;
      this.saveData.comp_id = this.comp_id;
      this.saveData.SQL_SELECT = this.listInterface;
      if (this.type === 'J2D') this.saveData.SQL_SELECT = [];
      for (let i = 0; i < this.statusUpdate.length; i++) {
        switch (this.statusUpdate[i].name) {
          case 'Processing':
            this.saveData.SQL_PROCESS = [];
            if (this.statusUpdate[i].col && this.statusUpdate[i].val) {
              this.saveData.SQL_PROCESS.push({
                col: this.statusUpdate[i].col,
                val: this.statusUpdate[i].val,
              });
            }
            break;
          case 'Complete':
            this.saveData.SQL_COMPLETE = [];
            if (this.statusUpdate[i].col && this.statusUpdate[i].val) {
              this.saveData.SQL_COMPLETE.push({
                col: this.statusUpdate[i].col,
                val: this.statusUpdate[i].val,
              });
            }
            break;
          case 'Error':
            this.saveData.SQL_ERROR = [];
            if (this.statusUpdate[i].col && this.statusUpdate[i].val) {
              this.saveData.SQL_ERROR.push({
                col: this.statusUpdate[i].col,
                val: this.statusUpdate[i].val,
              });
            }
            break;
          case 'Extra':
            this.saveData.SQL_EXTRA = [];
            if (this.statusUpdate[i].col && this.statusUpdate[i].val) {
              this.saveData.SQL_EXTRA.push({
                col: this.statusUpdate[i].col,
                val: this.statusUpdate[i].val,
              });
            }
            break;
          default:
            break;
        }
      }
    },
    onSave() {
      let validResult = this.$refs.form.validate();
      if (!validResult) return;

      if (this.type !== 'J2D') {
        if (this.listInterface.length === 0) {
          this.requiredCondition = this.$t('msg.dbAdapter.requiredInterfaceToSave');
          return;
        }
        let index = this.listInterface.findIndex((e) => e.col === '' || e.val === '');
        if (index > -1) {
          let item = this.listInterface[index];
          this.$refs[`${!item.col ? 'COL' : 'VAL'}_${item.id}`][0].focus();
          return;
        }
      }

      this.getParamSave();

      if (!this.saveData.CONF_ID) this.saveData.type_check = 'ConfigName';
      else {
        const editedData = this.getEditData(this.saveData, this.originData);
        if (Object.keys(editedData).length !== 0) {
          this.saveData.type_check = 'ConfigUpdate';
        }
      }

      this.saveData.dba_type = this.dbType;
      if (!this.saveData.type_check) {
        this.confirmSave();
      } else {
        this.$store
          .dispatch('checkDBConfig', this.saveData)
          .then((res) => {
            if (res == 'OK') {
              this.confirmSave();
            } else if (res == 'Confirm') {
              this.$refs.updateConfig.dialog = true;
            } else {
              this.add_valid_str = res;
              this.$refs.validateName.dialog = true;
            }
          })
          .catch((ex) => {
            this.$refs.fail.dialog = true;
          });
      }
    },
    confirmSave() {
      this.$emit('save-db-config', this.saveData);
    },
    getEditData(formData, loadFormData) {
      let keyArr = Object.keys(loadFormData);
      let editedData = {};
      for (let i = 0; i < keyArr.length; i++) {
        const from = formData[keyArr[i]];
        const to = loadFormData[keyArr[i]];
        if (from == undefined || to == undefined) continue;
        if (from.length >= 0) {
          if (JSON.stringify(from) != JSON.stringify(to)) {
            editedData[keyArr[i]] = from;
          }
        } else if (from !== to && from !== null) {
          editedData[keyArr[i]] = from;
        }
      }
      return editedData;
    },
    loadItem(configId) {
      this.sqlMessList = [];
      this.requiredCondition = '';
      this.dbConfig = this.dbConfigList;
      this.statusUpdate = [];
      this.$store.dispatch('getAdapterId', { id: configId }).then(() => {
        this.saveData = {
          CONF_ID: this.dbAdapter?.configInfo[0]?.config_id || '',
          CONF_NAME: this.dbAdapter?.configInfo[0]?.config_name,
          CONF_FROM: this.dbAdapter?.configInfo[0]?.config_from,
          CONF_TO: this.dbAdapter?.configInfo[0]?.config_to,
          CONF_MODULE: this.dbAdapter?.configInfo[0]?.config_module,
          CONF_DBINSTANCE: this.dbAdapter?.configInfo[0]?.config_db_instance,
          CONF_TABLE: this.dbAdapter?.configInfo[0]?.config_table,
        };
        this.originData = { ...this.saveData };
        this.$store.commit('SET_STORE_DBCONFIG_ID', this.saveData.CONF_ID);
        this.checkSelectBoth();
        this.originData.SQL_SELECT = [];
        this.listInterface = [];
        for (let i = 0; i < this.dbAdapter.selectSQL.length; i++) {
          this.listInterface.push({
            col: this.dbAdapter.selectSQL[i].col || '',
            val: this.dbAdapter.selectSQL[i].val,
          });
          this.originData.SQL_SELECT.push({
            col: this.dbAdapter.selectSQL[i].col || '',
            val: this.dbAdapter.selectSQL[i].val,
          });
        }

        let key = Object.keys(this.dbAdapter);
        let dbList = { ...this.dbAdapter };
        for (let i = 0; i < key.length; i++) {
          let list = dbList[`${key[i]}`];
          switch (key[i]) {
            case 'configInfo':
            case 'selectSQL':
              delete dbList[key[i]];
              break;
            case 'completeSQL':
              if (list[0] == undefined) {
                this.statusUpdate.push({ name: 'Complete' });
                break;
              }
              this.statusUpdate.push({
                col: list[0].col || '',
                val: list[0].val,
                name: 'Complete',
              });
              break;
            case 'errorSQL':
              if (list[0] == undefined) {
                this.statusUpdate.push({ name: 'Error' });
                break;
              }
              this.statusUpdate.push({
                col: list[0].col || '',
                val: list[0].val,
                name: 'Error',
              });
              break;
            case 'extraSQL':
              if (list[0] == undefined) {
                this.statusUpdate.push({ name: 'Extra' });
                break;
              }
              this.statusUpdate.push({
                col: list[0].col || '',
                val: list[0].val,
                name: 'Extra',
              });
              break;
            case 'processSQL':
              if (list[0] == undefined) {
                this.statusUpdate.push({ name: 'Processing' });
                break;
              }
              this.statusUpdate.push({
                col: list[0].col || '',
                val: list[0].val,
                name: 'Processing',
              });
              break;
            default:
              break;
          }
        }

        for (let i = 0; i < this.statusUpdate.length; i++) {
          switch (this.statusUpdate[i].name) {
            case 'Processing':
              this.originData.SQL_PROCESS = [];
              if (this.statusUpdate[i].col && this.statusUpdate[i].val) {
                this.originData.SQL_PROCESS.push({
                  col: this.statusUpdate[i].col,
                  val: this.statusUpdate[i].val,
                });
              }
              break;
            case 'Complete':
              this.originData.SQL_COMPLETE = [];
              if (this.statusUpdate[i].col && this.statusUpdate[i].val) {
                this.originData.SQL_COMPLETE.push({
                  col: this.statusUpdate[i].col,
                  val: this.statusUpdate[i].val,
                });
              }
              break;
            case 'Error':
              this.originData.SQL_ERROR = [];
              if (this.statusUpdate[i].col && this.statusUpdate[i].val) {
                this.originData.SQL_ERROR.push({
                  col: this.statusUpdate[i].col,
                  val: this.statusUpdate[i].val,
                });
              }
              break;
            case 'Extra':
              this.originData.SQL_EXTRA = [];
              if (this.statusUpdate[i].col && this.statusUpdate[i].val) {
                this.originData.SQL_EXTRA.push({
                  col: this.statusUpdate[i].col,
                  val: this.statusUpdate[i].val,
                });
              }
              break;
            default:
              break;
          }
        }

        this.handleChangeName();
      });
      this.saveData.type_check =
        this.$route.params.action == 'Edit' ? 'ConfigUpdate' : 'ConfigUsed';
      this.saveData.dba_id = this.dbaId;
      this.saveData.dba_conf_id = configId;
      this.$store.dispatch('checkDBConfig', this.saveData).then((res) => {
        if (res == 'OK') {
          this.allowEdit = true;
        } else {
          this.allowEdit = false;
        }
      });
    },
    loadAndCopyItem(configId) {
      this.sqlMessList = [];
      this.requiredCondition = '';
      this.dbConfig = this.dbConfigList;
      this.statusUpdate = [];
      this.$store.dispatch('getAdapterId', { id: configId }).then(() => {
        this.saveData = {
          CONF_ID: '',
          CONF_NAME: '',
          CONF_FROM: '',
          CONF_TO: '',
          CONF_MODULE: '',
          CONF_DBINSTANCE: this.dbAdapter?.configInfo[0]?.config_db_instance,
          CONF_TABLE: this.dbAdapter?.configInfo[0]?.config_table,
        };
        this.checkSelectBoth();
        this.listInterface = [];
        for (let i = 0; i < this.dbAdapter.selectSQL.length; i++) {
          this.listInterface.push({
            col: this.dbAdapter.selectSQL[i].col || '',
            val: this.dbAdapter.selectSQL[i].val,
          });
        }

        let key = Object.keys(this.dbAdapter);
        let dbList = { ...this.dbAdapter };
        for (let i = 0; i < key.length; i++) {
          let list = dbList[`${key[i]}`];
          switch (key[i]) {
            case 'configInfo':
            case 'selectSQL':
              delete dbList[key[i]];
              break;
            case 'completeSQL':
              if (list[0] == undefined) {
                this.statusUpdate.push({ name: 'Complete' });
                break;
              }
              this.statusUpdate.push({
                col: list[0].col || '',
                val: list[0].val,
                name: 'Complete',
              });
              break;
            case 'errorSQL':
              if (list[0] == undefined) {
                this.statusUpdate.push({ name: 'Error' });
                break;
              }
              this.statusUpdate.push({
                col: list[0].col || '',
                val: list[0].val,
                name: 'Error',
              });
              break;
            case 'extraSQL':
              if (list[0] == undefined) {
                this.statusUpdate.push({ name: 'Extra' });
                break;
              }
              this.statusUpdate.push({
                col: list[0].col || '',
                val: list[0].val,
                name: 'Extra',
              });
              break;
            case 'processSQL':
              if (list[0] == undefined) {
                this.statusUpdate.push({ name: 'Processing' });
                break;
              }
              this.statusUpdate.push({
                col: list[0].col || '',
                val: list[0].val,
                name: 'Processing',
              });
              break;
            default:
              break;
          }
        }
      });
      this.saveData.type_check =
        this.$route.params.action == 'Edit' ? 'ConfigUpdate' : 'ConfigUsed';
    },
    addInterface() {
      let index =
        this.listInterface.length > 0
          ? this.listInterface[this.listInterface.length - 1].id + 1
          : 1;
      this.listInterface.push({ id: index, val: '' });
    },
    removeInterface(item, index) {
      this.listInterfaceDelete.push(this.listInterface[index]);
      this.listInterface.splice(index, 1);
    },
    handleChangeConfigData(configId) {
      this.resetDBConfigData();
      if (configId) this.menuOpen = false;
      this.loadItem(configId);
      this.$emit('change-disabled-tab');
    },
    handleChangeAndCopyConfigData(configId) {
      this.resetDBConfigData();
      if (configId) this.menuOpen = false;
      this.loadAndCopyItem(configId);
    },
    selectQueryList(condition) {
      this.sqlMessList = [];
      this.requiredCondition = '';
      if (!this.saveData.CONF_FROM) {
        this.requiredCondition += 'Origin System';
      }
      if (!this.saveData.CONF_TO) {
        if (this.requiredCondition) this.requiredCondition += ', Target System';
        else this.requiredCondition += 'Target System';
      }
      if (!this.saveData.CONF_MODULE) {
        if (this.requiredCondition) this.requiredCondition += ', Interface Module';
        else this.requiredCondition += 'Interface Module';
      }
      if (!this.saveData.CONF_ADDRESS) {
        if (this.requiredCondition) this.requiredCondition += ', DB Instance';
        else this.requiredCondition += 'DB Instance';
      }
      if (!this.saveData.CONF_PORT) {
        if (this.requiredCondition) this.requiredCondition += ', Interface Control Table';
        else this.requiredCondition += 'Interface Control Table';
      }
      if (condition === 'phrase' && !this.saveData.WHERE_PHRASE) {
        if (this.requiredCondition) this.requiredCondition += ', Where Phrase';
        else this.requiredCondition += 'Where Phrase';
      }
      if (condition === 'interface') {
        if (this.listInterface.length === 0) {
          if (this.requiredCondition) this.requiredCondition += ' ,Interface Condition';
          else this.requiredCondition += 'Interface Condition';
        }
        let index = this.listInterface.findIndex((e) => e.col === '' || e.val === '');
        if (index > -1) {
          let item = this.listInterface[index];
          this.$refs[`${!item.col ? 'COL' : 'VAL'}_${item.id}`][0].focus();
          if (this.requiredCondition) this.requiredCondition += ' ,Interface Condition';
          else this.requiredCondition += 'Interface Condition';
        }
      }
      if (this.requiredCondition) {
        if (this.requiredCondition.includes(','))
          this.requiredCondition += '  are required to query.';
        else this.requiredCondition += '  is required to query.';
        return;
      }
      let _this = this.$refs.hotTableComponent.hotInstance;
      this.$emit('isLoad', true);
      this.$store
        .dispatch('selectQueryList', {
          CONF_ADDRESS: this.saveData.CONF_ADDRESS,
          CONF_PORT: this.saveData.CONF_PORT,
          CONF_DBINSTANCE: this.saveData.CONF_DBINSTANCE,
          CONF_TABLE: this.saveData.CONF_TABLE,
          CONF_ID: this.saveData.CONF_ID ? this.saveData.CONF_ID : 'slq-config',
          CONF_FROM: this.saveData.CONF_FROM,
          CONF_TO: this.saveData.CONF_TO,
          CONF_MODULE: this.saveData.CONF_MODULE,
          listInterface: this.listInterface,
          WHERE_PHRASE: this.saveData.WHERE_PHRASE,
          condition: condition,
        })
        .then(() => {
          this.$emit('isLoad', false);
          this.dataRows = this.interfaceColumnList.dataRows;
          this.resetSave();
          _this.loadData(this.dataRows);
          if (this.dataRows.length === 0)
            this.sqlMessList.push({
              icon: 'validate',
              message: 'No Data Found.',
            });
          else this.sqlMessList.push({ icon: 'completed', message: 'Completed.' });
          _this.selectCell(0, 0);
          _this.render();
        })
        .catch(() => {
          this.$emit('isLoad', false);
          this.sqlMessList.push({
            icon: 'validate',
            message: 'Unable to query.',
          });
          this.dataRows = [];
          this.resetSave();
          _this.loadData([]);
          _this.render();
        });
    },
    searchQueryData() {
      let search = this.textSearch;
      if (search === '') this.dataRows = this.interfaceColumnList.dataRows;
      let _this = this.$refs.hotTableComponent.hotInstance;
      let dataRows = this.interfaceColumnList.dataRows;
      let results = { dataRows: [] };
      for (let i = 0; i < dataRows.length; i++) {
        if (dataRows[i]['SYS_FROM'] && dataRows[i]['SYS_FROM'].includes(search.toUpperCase())) {
          results.dataRows.push(dataRows[i]);
          continue;
        } else if (dataRows[i]['SYS_TO'] && dataRows[i]['SYS_TO'].includes(search.toUpperCase())) {
          results.dataRows.push(dataRows[i]);
          continue;
        } else if (
          dataRows[i]['IF_MODULE_ID'] &&
          dataRows[i]['IF_MODULE_ID'].includes(search.toUpperCase())
        ) {
          results.dataRows.push(dataRows[i]);
          continue;
        } else if (
          dataRows[i]['MSG_NAME'] &&
          dataRows[i]['MSG_NAME'].includes(search.toUpperCase())
        ) {
          results.dataRows.push(dataRows[i]);
          continue;
        } else if (
          dataRows[i]['IN_OUT_IND'] &&
          dataRows[i]['IN_OUT_IND'].includes(search.toUpperCase())
        ) {
          results.dataRows.push(dataRows[i]);
          continue;
        } else if (
          dataRows[i]['PROC_STS'] &&
          dataRows[i]['PROC_STS'].includes(search.toUpperCase())
        ) {
          results.dataRows.push(dataRows[i]);
          continue;
        } else if (
          dataRows[i]['CRE_USR_ID'] &&
          dataRows[i]['CRE_USR_ID'].includes(search.toUpperCase())
        ) {
          results.dataRows.push(dataRows[i]);
          continue;
        }
      }
      this.dataRows = results.dataRows;
      this.resetSave();
      _this.loadData(this.dataRows);
      this.$refs.searchFilterData.focus();
      _this.render();
    },
    manageQueryList() {
      this.sqlMessList = [];
      let countInsert = 0;
      let countUpdate = 0;
      this.uploadQueryPool.forEach((item) => {
        if (item.SYSSTATUS === 'I') {
          countInsert++;
        } else if (item.SYSSTATUS === 'U') {
          countUpdate++;
        }
      });
      this.$emit('isLoad', true);
      this.$store
        .dispatch('manageQueryList', {
          CONF_ADDRESS: this.saveData.CONF_ADDRESS,
          CONF_PORT: this.saveData.CONF_PORT,
          CONF_DBINSTANCE: this.saveData.CONF_DBINSTANCE,
          CONF_TABLE: this.saveData.CONF_TABLE,
          CONF_ID: this.saveData.CONF_ID ? this.saveData.CONF_ID : 'slq-config',
          CONF_FROM: this.saveData.CONF_FROM,
          CONF_TO: this.saveData.CONF_TO,
          CONF_MODULE: this.saveData.CONF_MODULE,
          uploadQueryPool: this.uploadQueryPool,
        })
        .then(() => {
          this.$emit('isLoad', false);
          if (countInsert > 0)
            this.sqlMessList.push({
              icon: 'completed',
              message: 'Inserted ' + countInsert + ' Row(s)',
            });
          if (countUpdate > 0)
            this.sqlMessList.push({
              icon: 'completed',
              message: 'Updated ' + countUpdate + ' Row(s)',
            });

          this.resetSave();
        })
        .catch(() => {
          this.$emit('isLoad', false);
          this.sqlMessList.push({
            icon: 'validate',
            message: 'Insert or update failed',
          });
          this.resetSave();
        });
    },
    handleChangeName() {
      this.$emit('change-name', {
        name:
          nullOrEmpty(this.saveData.CONF_FROM) +
          '_' +
          nullOrEmpty(this.saveData.CONF_TO) +
          '_' +
          nullOrEmpty(this.saveData.CONF_MODULE),
        dbIns: this.saveData.CONF_DBINSTANCE,
      });
    },
    checkSelectBoth() {
      this.connect = '';
      if (this.saveData.CONF_TABLE && this.saveData.CONF_DBINSTANCE) {
        this.$emit('isLoad', true);
        this.$store
          .dispatch('getAgentAdapterList')
          .then(() => {
            const listData = this.$store.getters.agentAdapterList;
            const index = listData.findIndex((e) => e.agentId == this.agent_id);
            if (index > -1) {
              const item = listData[index];
              this.saveData.CONF_ADDRESS = item.agentAddress;
              this.saveData.CONF_PORT = item.agentPort;
              let _this = this.$refs.hotTableComponent.hotInstance;
              this.$store
                .dispatch('getInterfaceColumnList', {
                  CONF_ADDRESS: item.agentAddress,
                  CONF_PORT: item.agentPort,
                  CONF_DBINSTANCE: this.saveData.CONF_DBINSTANCE,
                  CONF_TABLE: this.saveData.CONF_TABLE,
                })
                .then(() => {
                  this.connect = 'success';
                  this.columnName = this.interfaceColumnList.columnName;
                  this.dataRows = this.interfaceColumnList.dataRows;
                  this.resetSave();
                  _this.loadData(this.dataRows);
                  _this.selectCell(0, 0);
                  _this.render();
                  if (this.dataRows.length === 0) {
                    _this.alter('insert_row', _this.countRows());
                    _this.selectCell(_this.countRows() - 1, 'MSG_NAME');
                  }
                })
                .catch(() => {
                  this.$emit('isLoad', false);
                  this.connect = 'fail';
                  this.columnName = [];
                  this.dataRows = [];
                  this.resetSave();
                  _this.loadData([]);
                  _this.render();
                });
            }
            this.$emit('isLoad', false);
          })
          .catch(() => {
            this.$emit('isLoad', false);
          });
      }
    },
    resetSave() {
      this.deleteList = [];
      this.updateList = [];
      this.uploadQueryPool = [];
    },
    resetDBConfigData() {
      this.columnName = [];
      this.dataRows = [];
      this.listInterface = [{ id: 0, val: '' }];
      this.value = '';
      this.statusUpdate = [
        { val: '', name: 'Processing' },
        { val: '', name: 'Complete' },
        { val: '', name: 'Error' },
        { val: '', name: 'Extra' },
      ];
      this.saveData = {
        CONF_ID: '',
        CONF_NAME: '',
        CONF_TABLE: '',
        CONF_DBINSTANCE: '',
        CONF_FROM: '',
        CONF_TO: '',
        CONF_MODULE: '',
        SQL_SELECT: [],
        SQL_PROCESS: [],
        SQL_COMPLETE: [],
        SQL_ERROR: [],
        SQL_EXTRA: [],
      };
      this.originData = {
        CONF_ID: '',
        CONF_NAME: '',
        CONF_TABLE: '',
        CONF_DBINSTANCE: '',
        CONF_FROM: '',
        CONF_TO: '',
        CONF_MODULE: '',
        SQL_SELECT: [],
        SQL_PROCESS: [],
        SQL_COMPLETE: [],
        SQL_ERROR: [],
        SQL_EXTRA: [],
      };
      this.$store.commit('SET_STORE_DBCONFIG_ID', '');
    },
    handleDelete(config) {
      this.$store
        .dispatch('checkDBConfig', {
          dba_id: this.dbaId,
          dba_conf_id: config.value,
          type_check: 'ConfigUpdate',
        })
        .then((res) => {
          if (res == 'Confirm') {
            this.add_valid_str = "Can't delete because multi DB are using this config. ";
            this.$refs.validateName.dialog = true;
          } else {
            this.deleteData = config.value;
            this.deleteDataName = config.text;
            this.$refs.confirmDeleteFileDialog.dialog = true;
          }
        })
        .catch((ex) => {
          this.$refs.fail.dialog = true;
        });
    },
    okDeleteDBConfig(item) {
      this.saveData.CONF_ID = item;
      this.$emit('delete-db-config', this.saveData);
    },
  },
};
</script>

<style>
.load-menu {
  margin-top: 8px;
  contain: initial;
  overflow: visible;
}
.theme--light .load-menu span.v-btn__content {
  color: #000000;
  font-weight: 400;
}

.theme--light .load-menu .v-text-field__slot {
  border: 1px solid #c5d1e3;
  border-radius: 4px;
}
.load-menu::before {
  position: absolute;
  content: '';
  top: 0;
  left: 22px;
  transform: translateY(-100%);
  width: 10px;
  height: 13px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid #fff;
}
.btn-delete-dbcfg span.v-btn__content {
  color: #7b839d !important;
}
.inline-block-component {
  display: flex;
}
.cus-autocomplete.v-input__slot {
  border: 1px solid #e2e8f0;
}
.ht_clone_top {
  z-index: 8 !important;
}
</style>
